import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy, Component, computed, ElementRef, HostBinding, input, output, viewChild,
} from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { OnboardingPreviewStage, UserOnboardingStage } from '@pt/models';
import {
  AchievementComponent,
  CoinComponent,
  TemplateStageImageComponent, ScrollShadowComponent,
} from '@pt/components';
import { IconModule, TimerComponent } from '@hglobal/common';

import { StageBaseComponent } from '../abstructions/stage-base.component';

@Component({
  selector: 'pt-onboarding-stage',
  templateUrl: './onboarding-stage.component.html',
  styleUrl: './onboarding-stage.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    TranslateModule,
    CoinComponent,
    IconModule,
    TimerComponent,
    AchievementComponent,
    TemplateStageImageComponent,
    NgTemplateOutlet,
    ScrollShadowComponent,
  ],
})
export class OnboardingStageComponent
  extends StageBaseComponent<UserOnboardingStage | OnboardingPreviewStage> {
  // @HostBinding('class.pt-onboarding-stage_completed') get isCompleted() {
  //   return this.stage().status === 'completed';
  // }
  //
  // @HostBinding('class.pt-onboarding-stage_blocked') get isBlocked() {
  //   return !this.stage().status;
  // }
  //
  // @HostBinding('class') get onboardingTypeClass() {
  //   return this.isCompleted ? this.onboardingType() : '';
  // }
}
